import{commonjsGlobal as f}from"../../_virtual/_commonjsHelpers.js";var e;typeof window<"u"?e=window:typeof f<"u"?e=f:typeof self<"u"?e=self:e={};var o=e;export{o as default};
